(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var cells = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.cells = cells;
        this.restart();
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(i) {
                    var row = _this.board[i].filter(function(val) {
                        return val !== 0;
                    });
                    var newRow = [];
                    for(var j = 0; j < row.length; j++)if (row[j] === row[j + 1]) {
                        newRow.push(row[j] * 2);
                        _this.score += row[j] * 2;
                        j++;
                        moved = true;
                    } else newRow.push(row[j]);
                    while(newRow.length < 4)newRow.push(0);
                    if (_this.board[i].toString() !== newRow.toString()) {
                        _this.board[i] = newRow;
                        moved = true;
                    }
                };
                if (this.status !== "playing") return;
                var moved = false;
                for(var i = 0; i < 4; i++)_loop(i);
                if (moved) this.addRandomTile();
                this.checkGameOver();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(i) {
                    var row = _this.board[i].filter(function(val) {
                        return val !== 0;
                    }).reverse();
                    var newRow = [];
                    var j = 0;
                    while(j < row.length)if (row[j] === row[j + 1]) {
                        newRow.push(row[j] * 2);
                        _this.score += row[j] * 2;
                        j += 2;
                        moved = true;
                    } else {
                        newRow.push(row[j]);
                        j++;
                    }
                    while(newRow.length < 4)newRow.push(0);
                    newRow.reverse();
                    if (_this.board[i].toString() !== newRow.toString()) {
                        _this.board[i] = newRow;
                        moved = true;
                    }
                };
                if (this.status !== "playing") return;
                var moved = false;
                for(var i = 0; i < 4; i++)_loop(i);
                if (moved) this.addRandomTile();
                this.checkGameOver();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                if (this.status !== "playing") return;
                var moved = false;
                for(var col = 0; col < 4; col++){
                    var column = [];
                    for(var row = 0; row < 4; row++)if (this.board[row][col] !== 0) column.push(this.board[row][col]);
                    var newColumn = [];
                    var i = 0;
                    while(i < column.length)if (column[i] === column[i + 1]) {
                        newColumn.push(column[i] * 2);
                        this.score += column[i] * 2;
                        i += 2;
                    } else {
                        newColumn.push(column[i]);
                        i++;
                    }
                    while(newColumn.length < 4)newColumn.push(0);
                    for(var row1 = 0; row1 < 4; row1++){
                        if (this.board[row1][col] !== newColumn[row1]) moved = true;
                        this.board[row1][col] = newColumn[row1];
                    }
                }
                if (moved) this.addRandomTile();
                this.checkGameOver();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                if (this.status !== "playing") return;
                var moved = false;
                for(var col = 0; col < 4; col++){
                    var column = [];
                    for(var row = 0; row < 4; row++)if (this.board[row][col] !== 0) column.push(this.board[row][col]);
                    var newColumn = [];
                    var i = column.length - 1;
                    while(i >= 0)if (column[i] === column[i - 1]) {
                        newColumn.unshift(column[i] * 2);
                        this.score += column[i] * 2;
                        i -= 2;
                        moved = true;
                    } else {
                        newColumn.unshift(column[i]);
                        i--;
                    }
                    while(newColumn.length < 4)newColumn.unshift(0);
                    for(var row1 = 0; row1 < 4; row1++){
                        if (this.board[row1][col] !== newColumn[row1]) moved = true;
                        this.board[row1][col] = newColumn[row1];
                    }
                }
                if (moved) this.addRandomTile();
                this.checkGameOver();
            }
        },
        {
            key: "checkGameOver",
            value: function checkGameOver() {
                if (this.board.some(function(row) {
                    return row.includes(2048);
                })) this.status = "win";
                else if (!this.canMove()) this.status = "lose";
            }
        },
        {
            key: "canMove",
            value: function canMove() {
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    if (this.board[i][j] === 0) return true;
                    if (j < 3 && this.board[i][j] === this.board[i][j + 1]) return true;
                    if (i < 3 && this.board[i][j] === this.board[i + 1][j]) return true;
                }
                return false;
            }
        },
        {
            key: "displayGameStatus",
            value: function displayGameStatus(stat) {
                var winMessage = document.querySelector(".message-win");
                var loseMessage = document.querySelector(".message-lose");
                winMessage.classList.add("hidden");
                loseMessage.classList.add("hidden");
                if (stat === "win") winMessage.classList.remove("hidden");
                else if (stat === "lose") loseMessage.classList.remove("hidden");
                else if (stat === "playing") {
                    winMessage.classList.add("hidden");
                    loseMessage.classList.add("hidden");
                }
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
            }
        },
        {
            /**
   * Returns the current game status.
	@@ -50,19 +278,58 @@ class Game {
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.status = "playing";
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.board = this.cells.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                this.score = 0;
                this.status = "idle";
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = [];
                this.board.forEach(function(row, rowIndex) {
                    row.forEach(function(value, colIndex) {
                        if (value === 0) emptyCells.push({
                            rowIndex: rowIndex,
                            colIndex: colIndex
                        });
                    });
                });
                if (emptyCells.length > 0) {
                    var randomIndex = Math.floor(Math.random() * emptyCells.length);
                    var _emptyCells_randomIndex = emptyCells[randomIndex], rowIndex = _emptyCells_randomIndex.rowIndex, colIndex = _emptyCells_randomIndex.colIndex;
                    this.board[rowIndex][colIndex] = Math.random() < 0.9 ? 2 : 4;
                    var cell = document.querySelector('[data-position="'.concat(rowIndex, "-").concat(colIndex, '"]'));
                    requestAnimationFrame(function() {
                        cell.classList.add("field-cell--new");
                        setTimeout(function() {
                            cell.classList.remove("field-cell--new");
                        }, 300);
                    });
                }
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$scoreElement = document.querySelector(".game-score");
var $197cd56b15c33885$var$startButton = document.getElementById("ButtonStart");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
function $197cd56b15c33885$var$updateBoard() {
    var state = $197cd56b15c33885$var$game.getState();
    state.forEach(function(row, rowIndex) {
        row.forEach(function(value, colIndex) {
            var cell = document.querySelector('[data-position="'.concat(rowIndex, "-").concat(colIndex, '"]'));
            cell.textContent = value !== 0 ? value : "";
            $197cd56b15c33885$var$updateCellClass(cell, value);
        });
    });
}
function $197cd56b15c33885$var$updateCellClass(cell, value) {
    cell.className = "field-cell";
    if (value !== 0) cell.classList.add("field-cell--".concat(value));
}
function $197cd56b15c33885$var$updateScore() {
    $197cd56b15c33885$var$scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
}
function $197cd56b15c33885$var$updateMessages() {
    // eslint-disable-next-line no-shadow
    var status = $197cd56b15c33885$var$game.getStatus();
    if (status === "win") {
        $197cd56b15c33885$var$messageWin.classList.remove("hidden");
        $197cd56b15c33885$var$messageLose.classList.add("hidden");
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
    } else if (status === "lose") {
        $197cd56b15c33885$var$messageLose.classList.remove("hidden");
        $197cd56b15c33885$var$messageWin.classList.add("hidden");
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
    } else if (status === "idle") {
        $197cd56b15c33885$var$messageStart.classList.remove("hidden");
        $197cd56b15c33885$var$messageWin.classList.add("hidden");
        $197cd56b15c33885$var$messageLose.classList.add("hidden");
    } else {
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
        $197cd56b15c33885$var$messageWin.classList.add("hidden");
        $197cd56b15c33885$var$messageLose.classList.add("hidden");
    }
}
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$startButton.classList.contains("start")) {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$updateBoard();
        $197cd56b15c33885$var$updateMessages();
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.classList.add("restart");
        $197cd56b15c33885$var$startButton.textContent = "Restart";
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$updateBoard();
        $197cd56b15c33885$var$updateScore();
        $197cd56b15c33885$var$updateMessages();
        $197cd56b15c33885$var$startButton.classList.remove("restart");
        $197cd56b15c33885$var$startButton.classList.add("start");
        $197cd56b15c33885$var$startButton.textContent = "Start";
    }
});
// eslint-disable-next-line no-shadow
window.addEventListener("keydown", function(event) {
    switch(event.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    $197cd56b15c33885$var$updateBoard();
    $197cd56b15c33885$var$updateScore();
    $197cd56b15c33885$var$updateMessages();
});

})();
//# sourceMappingURL=index.3c391bdc.js.map
